import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useViewIndustryQuery } from "../../hooks/industry/industryList";
import { ArrowLeft } from "lucide-react";
import { useViewSingleIndustry } from "../../hooks/industry/viewSinglePage";
import FallbackImage from "../../components/common/fallbackImage";
import { resolveImageUrl } from "../../utils/resolveImageUrl";

const toBool = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (["true", "1", "active", "enabled", "yes"].includes(s)) return true;
    if (["false", "0", "inactive", "disabled", "no"].includes(s)) return false;
  }
  return false;
};

const ViewIndustry = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useViewSingleIndustry(id);
  const { data: industriesData } = useViewIndustryQuery();

  const industry = data?.data || data;

  if (isLoading) return <div>Loading client...</div>;
  if (isError) return <div>Error loading client</div>;

  return (
    <>
      <h5>
        <button className="back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back to Industries
        </button>
      </h5>

      {/* <h2 style={{ color: "#5C308D", marginBottom: "20px" }}>
        {" "}
        {client?.name || "Client"} Details
      </h2> */}
      <div className="page-body" style={{ marginTop: 30 }}>
        <div
          className="client-view-card"
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "10px",
            background: "#fff",
            width: "100%",
          }}
        >
          {industry?.image && (
            <FallbackImage
              src={industry.image}
              alt="Industry"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                marginBottom: "20px",
              }}
            />
          )}

          <div className="client-grid">
            <div className="field">
              <span className="label">Title</span>
              <span className="value">{industry?.title || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Status</span>
              <span className="value">
                {toBool(
                  typeof industry?.isActive !== "undefined"
                    ? industry?.isActive
                    : industry?.status,
                )
                  ? "Active"
                  : "Inactive"}
              </span>
            </div>

            <div className="field">
              <span className="label">Location</span>
              <span className="value">{industry?.location || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Description</span>
              <span className="value">{industry?.description || "-"}</span>
            </div>

            <div className="field">
              <span className="label">Catalogs</span>

              <div className="value">
                {industry?.catlogs?.length ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {industry.catlogs.map((cat, index) => {
                      const fileUrl = resolveImageUrl(cat.file);
                      const fileName = cat.file?.split("/").pop();

                      return (
                        <div
                          key={cat._id || index}
                          style={{
                            padding: "12px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "10px",
                            background: "#f9fafb",
                          }}
                        >
                          <div
                            style={{ fontWeight: "600", marginBottom: "4px" }}
                          >
                            {cat.title || "No Title"}
                          </div>

                          <div
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              marginBottom: "6px",
                            }}
                          >
                            {cat.description || "No Description"}
                          </div>

                          {cat.file && (
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#5C308D", fontSize: "14px" }}
                            >
                              📄 {fileName}
                            </a>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewIndustry;
